import { css } from '@emotion/react';
import { classNames } from '@frontend/string';

export type RelativeContainerProps = React.PropsWithChildren<{
  className?: string;
}>;

const styles = css`
  position: relative;
`;
export const RelativeContainer = ({ children, className }: RelativeContainerProps) => {
  return (
    <div className={classNames('payment-methods__relative-container', className)} css={styles}>
      {children}
    </div>
  );
};
